<template>
    <div>
        <div class="w-full md:w-4/5 m-auto py-6 px-12">
            <div v-if="loading" class="lds-spinner">
                <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
            </div>
            <h1 class="mb-4 text-lshtm-primary text-2xl text-left font-bold text-2xl">Manage Your Applications</h1>
            <div class="flex flex-wrap bg-gray-100 border px-4 py-1 mt-1 pb-6">
                <div class="w-full text-left py-4 relative flex flex-wrap">
                    <div class="w-full mb-2 text-sm"><span v-if="loading">Fetching your applications...</span><span v-else /></div>
                </div>
                <div v-if="applicationData.data?.length === 0" class="w-full flex flex-col items-center -mt-10">
                    <form action="#" class="w-1/4" @submit.prevent="create">
                        <button :disabled="loading" class="bg-green-600 hover:bg-green-700 cursor-pointer text-white py-2 px-4 w-full rounded mt-4 mr-2 btn-submit">
                            <div v-if="loading" class="cursor-pointer lds-ring-container">
                                <div class="cursor-pointer lds-ring"><div /><div /><div /><div /></div>
                            </div>
                            <span class="cursor-pointer">Create New Application</span>
                        </button>
                    </form>
                </div>
                <div v-else class="w-full">
                    <div v-for="(application,index) in applicationData.data" :key="index" class="w-full">
                        <div v-if="application.reference" class="bg-white border text-left border-gray-300 flex flex-wrap mb-4 p-8">
                            <div class="w-full md:w-1/2 divide-y divide-grey-400">
                                <div class="p-1">Application Reference</div>
                                <div class="p-1">Application Status</div>
                                <div class="p-1">Academic Year</div>
                                <div class="p-1">Programme Level</div>
                                <div class="p-1">Programme Name</div>
                            </div>
                            <div class="w-full md:w-1/2 divide-y divide-grey-400">
                                <div class="p-1">
                                    <p v-if="application.human_ref">{{ application.human_ref }}</p>
                                    <p v-else>&nbsp;</p>
                                </div>
                                <div class="p-1">
                                    <span>{{ application.public_status }}</span>
                                </div>
                                <div class="p-1">
                                    <p v-if="application.academicYear">{{ application.academicYear }}</p>
                                    <p v-else>&nbsp;</p>
                                </div>
                                <div class="p-1">
                                    <p v-if="application.programmeType">{{ application.programmeType }}</p>
                                    <p v-else>&nbsp;</p>
                                </div>
                                <div class="p-1">{{ application.programmeName }}</div>
                            </div>

                            <div class="flex justify-end w-full">
                                <div v-if="application.can_edit_referees" class="mt-4 mr-2 flex justify-end">
                                    <router-link :to="{ name: 'EditReferees',params:{id:application.reference} }">
                                        <button class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Referees and References</button>
                                    </router-link>
                                </div>

                                <div class="mt-4 flex justify-end">
                                    <router-link v-if="application.status !== 'Draft'" :to="{ name: 'ReviewApplication',params:{id:application.reference} }">
                                        <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Review application</button>
                                    </router-link>
                                </div>

                                <div class="mt-4 flex justify-end">
                                    <router-link v-if="application.status === 'Draft' && application.programme_code !== 'S'" :to="{ name: 'EditApplication',params:{id:application.reference} }">
                                        <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Edit application</button>
                                    </router-link>
                                </div>

                                <div class="mt-4 flex justify-end">
                                    <router-link v-if="application.status === 'Draft' && application.programme_code === 'S'" :to="{ name: 'EditModuleApplication',params:{id:application.reference} }">
                                        <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Continue short course application</button>
                                    </router-link>
                                </div>
                            </div>

                            <div v-if="application.status === 'Offered' || application.status === 'Offered, Registry Review (on hold)'"
                                 class="w-full mt-4 flex justify-end"
                            >
                                <router-link :to="{ name: 'ApplicationDecision', params:{id:application.reference} }">
                                    <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Make decision</button>
                                </router-link>
                            </div>
                            <div v-if="application.status === 'Awaiting Deposit'" class="w-full mt-4 flex justify-end">
                                <router-link :to="{ name: 'ApplicationDecision', params: { id: application.reference }}" class="bg-lshtm-primary hover:bg-lshtm-primary">View offer conditions</router-link>
                            </div>


                            <div class="mt-8 w-full">
                                <h2 v-if="application?.hasDocumentRequest" class="mb-2">Additional documentation is required from you, open the application to respond.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FileInput from '@/shared/FileInput'
import SelectInput from '@/shared/SelectInput'

export default {
    name: 'Application',
    metaInfo() {
        return {
            title: 'Application',
        }
    },
    components: {
        SelectInput,
        FileInput,
    },
    data() {
        return {
            form: ({
                reference: '',
                documentRequestReference: '',
                document_type: null,
                file: null,
            }),
            applicationData: [],
            loading: true,
            successMessage: '',
            serverError: '',

        }
    },
    computed: {
        applicationDetails() {
            return this.$store.getters.applicationDetails
        },
    },
    watch: {
        applicationDetails(data) {
            this.applicationData = data
            this.hasLoaded()
        },
    },
    created() {
        this.$store.dispatch('retrieveApplications')
            .then(() => {

            })
            .catch(() => {
            })
    },
    methods: {
        create() {
            this.loading = true
            this.$store.dispatch('createApplication')
                .then(() => {
                    window.location.reload(true)
                })
                .catch(() => {

                })
        },
        update() {
            this.loading = true
            const formData = new FormData()
            formData.append('file', this.form.file)
            formData.append('reference', this.form.reference)
            formData.append('document_request_reference', this.form.documentRequestReference)
            formData.append('document_type', this.form.document_type)
            this.$store.dispatch('uploadDocument', {
                applicationRef: this.form.reference,
                file: formData,
            })
                .then((response) => {
                    this.loading = false
                    this.successMessage = response.data
                    this.serverError = ''
                    location.reload()
                })
                .catch(error => {
                    this.loading = false
                    this.successMessage = ''
                    this.serverError = error.response.data.errors.file[0]
                })
        },
        hasLoaded() {
            this.loading = false
        },
        dirtyForm(applicationReference, reference) {
            this.form.reference = applicationReference
            this.form.documentRequestReference = reference
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>
